import toError from 'transport/adapters/vod/parsers/error';
import * as http from 'transport/utils/http';
import { keysToSnakeCase } from '@wix/wix-vod-shared/src/common/utils/object';
import { parseCards } from '@wix/wix-vod-shared/src/common/parsers/cards/cards';

const createError = (errorDescription, errorCode = 500) =>
  toError({
    status: errorCode,
    data: {
      errorCode,
      errorDescription,
    },
  });

const parseResponse = response => ({
  ...response,
  data: parseCards(response.data),
});

const serializeItemAction = itemActionData => keysToSnakeCase(itemActionData);

const createItemActionsPayload = (actionsList, serializeItem = _.identity) => ({
  data: {
    actions: _.map(actionsList, serializeItem),
  },
  options: {
    withClientCache: false,
  },
});


export default function initItemActions(settings/*, adapterMethods*/) {
  const getItemActionsEndpoint = itemId => `${settings.apiUrl}/catalog/items/${itemId}/actions`;
  // https://kb.wixpress.com/pages/viewpage.action?pageId=45417074
  const get = (trigger, itemId) => {
    if (!itemId) {
      return createError('no id provided');
    }

    return http.get(getItemActionsEndpoint(itemId))
      .then(parseResponse)
      .catch(toError);
  };

  // https://kb.wixpress.com/pages/viewpage.action?pageId=45417060
  const create = (trigger, itemId, actionsList) =>
    http.post(getItemActionsEndpoint(itemId), createItemActionsPayload(actionsList, serializeItemAction))
      .then(parseResponse)
      .catch(toError);

  const update = (trigger, itemId, actionsList) =>
    http.put(getItemActionsEndpoint(itemId), createItemActionsPayload(actionsList, serializeItemAction))
      .then(parseResponse)
      .catch(toError);

  // https://kb.wixpress.com/pages/viewpage.action?pageId=45417070
  const remove = (trigger, itemId, actionIdsList) =>
    http.del(getItemActionsEndpoint(itemId), createItemActionsPayload(actionIdsList))
      .catch(toError);

  return {
    get,
    create,
    update,
    remove,
  };
}



// WEBPACK FOOTER //
// ./src/transport/adapters/vod/item-actions.js